/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API for the Verdi Dashboard application
 * OpenAPI spec version: 1.0.0
 */

import type {
	DataTag,
	DefinedInitialDataOptions,
	DefinedUseQueryResult,
	MutationFunction,
	QueryClient,
	QueryFunction,
	QueryKey,
	UndefinedInitialDataOptions,
	UseMutationOptions,
	UseMutationResult,
	UseQueryOptions,
	UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { customFetch } from "../custom-fetch.ts";
import type {
	ExportDataStreamsCsv400,
	ExportDataStreamsCsv404,
	ExportDataStreamsCsv422,
	ExportDataStreamsCsv429,
	ExportDataStreamsCsv500,
	ExportDataStreamsCsv503,
	ExportDataStreamsCsv504,
	ExportDataStreamsCsvBody,
	GetDataStream200,
	GetDataStream400,
	GetDataStream404,
	GetDataStream500,
	ListDataStreamPoints200,
	ListDataStreamPoints400,
	ListDataStreamPoints403,
	ListDataStreamPoints404,
	ListDataStreamPoints500,
	ListDataStreamPointsParams,
	ListDataStreams200Item,
	ListDataStreams400,
	ListDataStreams500,
	ListDataStreamsParams,
	ListMultiStreamDataPoints200,
	ListMultiStreamDataPoints400,
	ListMultiStreamDataPoints403,
	ListMultiStreamDataPoints500,
	ListMultiStreamDataPointsParams,
	ListMultiStreamDataPointsPost200,
	ListMultiStreamDataPointsPost400,
	ListMultiStreamDataPointsPost403,
	ListMultiStreamDataPointsPost500,
	ListMultiStreamDataPointsPostBody,
	ListMultiStreamDataPointsQuery200,
	ListMultiStreamDataPointsQuery400,
	ListMultiStreamDataPointsQuery403,
	ListMultiStreamDataPointsQuery500,
	ListMultiStreamDataPointsQueryBody,
} from "./schemas";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
	query: T,
	queryKey: K,
): T & { queryKey: K } => {
	const result = { queryKey } as T & { queryKey: K };
	for (const key of Object.keys(query)) {
		// The explicit queryKey always wins, matching the previous
		// `{ ...query, queryKey }` spread where it was set last.
		if (key === "queryKey") continue;
		Object.defineProperty(result, key, {
			enumerable: true,
			configurable: true,
			get: () => (query as Record<string, unknown>)[key],
		});
	}
	return result;
};

export const getListDataStreamsUrl = (params?: ListDataStreamsParams) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		const explodeParameters = ["zoneIds", "unitCategories"];

		if (Array.isArray(value) && explodeParameters.includes(key)) {
			value.forEach((v) => {
				normalizedParams.append(key, v === null ? "null" : String(v));
			});
			return;
		}

		if (value !== undefined) {
			normalizedParams.append(key, value === null ? "null" : String(value));
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/data-streams?${stringifiedParams}`
		: `/data-streams`;
};

/**
 * @summary Discover data streams. Supports filtering by zone, device, sensor cluster address, depth, and geographic radius.
 */
export const listDataStreams = async (
	params?: ListDataStreamsParams,
	options?: Parameters<typeof customFetch>[1],
): Promise<ListDataStreams200Item[]> => {
	return customFetch<ListDataStreams200Item[]>(getListDataStreamsUrl(params), {
		...options,
		method: "GET",
	});
};

export const getListDataStreamsQueryKey = (params?: ListDataStreamsParams) => {
	return ["data-streams", ...(params ? [params] : [])] as const;
};

export const getListDataStreamsQueryOptions = <
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params?: ListDataStreamsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getListDataStreamsQueryKey(params);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof listDataStreams>>> = ({
		signal,
	}) => listDataStreams(params, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listDataStreams>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDataStreamsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listDataStreams>>
>;
export type ListDataStreamsQueryError = ListDataStreams400 | ListDataStreams500;

export function useListDataStreams<
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params: undefined | ListDataStreamsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDataStreams>>,
					TError,
					Awaited<ReturnType<typeof listDataStreams>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDataStreams<
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params?: ListDataStreamsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDataStreams>>,
					TError,
					Awaited<ReturnType<typeof listDataStreams>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDataStreams<
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params?: ListDataStreamsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Discover data streams. Supports filtering by zone, device, sensor cluster address, depth, and geographic radius.
 */

export function useListDataStreams<
	TData = Awaited<ReturnType<typeof listDataStreams>>,
	TError = ListDataStreams400 | ListDataStreams500,
>(
	params?: ListDataStreamsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreams>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListDataStreamsQueryOptions(params, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Discover data streams. Supports filtering by zone, device, sensor cluster address, depth, and geographic radius.
 */
export const useSetListDataStreamsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		params: ListDataStreamsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listDataStreams>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listDataStreams>> | undefined,
			  ) => Awaited<ReturnType<typeof listDataStreams>> | undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof listDataStreams>>>(
			{ exact: $exactMatch, queryKey: getListDataStreamsQueryKey(params) },
			updater,
		);
	};
};

/**
 * @summary Discover data streams. Supports filtering by zone, device, sensor cluster address, depth, and geographic radius.
 */
export const useGetListDataStreamsQueryData = () => {
	const queryClient = useQueryClient();
	return (params?: ListDataStreamsParams) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listDataStreams>>>(
			getListDataStreamsQueryKey(params),
		);
};

export const getGetDataStreamUrl = (streamId: number) => {
	return `/data-streams/${streamId}`;
};

/**
 * @summary Get a single data stream by ID
 */
export const getDataStream = async (
	streamId: number,
	options?: Parameters<typeof customFetch>[1],
): Promise<GetDataStream200> => {
	return customFetch<GetDataStream200>(getGetDataStreamUrl(streamId), {
		...options,
		method: "GET",
	});
};

export const getGetDataStreamQueryKey = (streamId: number) => {
	return ["data-streams", streamId] as const;
};

export const getGetDataStreamQueryOptions = <
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey = queryOptions?.queryKey ?? getGetDataStreamQueryKey(streamId);

	const queryFn: QueryFunction<Awaited<ReturnType<typeof getDataStream>>> = ({
		signal,
	}) => getDataStream(streamId, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: streamId !== null && streamId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof getDataStream>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDataStreamQueryResult = NonNullable<
	Awaited<ReturnType<typeof getDataStream>>
>;
export type GetDataStreamQueryError =
	| GetDataStream400
	| GetDataStream404
	| GetDataStream500;

export function useGetDataStream<
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options: {
		query: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDataStream>>,
					TError,
					Awaited<ReturnType<typeof getDataStream>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDataStream<
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof getDataStream>>,
					TError,
					Awaited<ReturnType<typeof getDataStream>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDataStream<
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a single data stream by ID
 */

export function useGetDataStream<
	TData = Awaited<ReturnType<typeof getDataStream>>,
	TError = GetDataStream400 | GetDataStream404 | GetDataStream500,
>(
	streamId: number,
	options?: {
		query?: Partial<
			UseQueryOptions<Awaited<ReturnType<typeof getDataStream>>, TError, TData>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getGetDataStreamQueryOptions(streamId, options);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get a single data stream by ID
 */
export const useSetGetDataStreamQueryData = () => {
	const queryClient = useQueryClient();
	return (
		streamId: number,
		updater:
			| Awaited<ReturnType<typeof getDataStream>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof getDataStream>> | undefined,
			  ) => Awaited<ReturnType<typeof getDataStream>> | undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<Awaited<ReturnType<typeof getDataStream>>>(
			{ exact: $exactMatch, queryKey: getGetDataStreamQueryKey(streamId) },
			updater,
		);
	};
};

/**
 * @summary Get a single data stream by ID
 */
export const useGetGetDataStreamQueryData = () => {
	const queryClient = useQueryClient();
	return (streamId: number) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof getDataStream>>>(
			getGetDataStreamQueryKey(streamId),
		);
};

export const getListDataStreamPointsUrl = (
	streamId: number,
	params?: ListDataStreamPointsParams,
) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		if (value !== undefined) {
			normalizedParams.append(
				key,
				value === null
					? "null"
					: value instanceof Date
						? value.toISOString()
						: String(value),
			);
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/data-streams/${streamId}/data-points?${stringifiedParams}`
		: `/data-streams/${streamId}/data-points`;
};

/**
 * @summary Query data points for a stream across all fragments. Flat by default; use pointsByFragment=true to see per-fragment boundaries.
 */
export const listDataStreamPoints = async (
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: Parameters<typeof customFetch>[1],
): Promise<ListDataStreamPoints200> => {
	return customFetch<ListDataStreamPoints200>(
		getListDataStreamPointsUrl(streamId, params),
		{
			...options,
			method: "GET",
		},
	);
};

export const getListDataStreamPointsQueryKey = (
	streamId: number,
	params?: ListDataStreamPointsParams,
) => {
	return [
		"data-streams",
		streamId,
		"data-points",
		...(params ? [params] : []),
	] as const;
};

export const getListDataStreamPointsQueryOptions = <
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListDataStreamPointsQueryKey(streamId, params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listDataStreamPoints>>
	> = ({ signal }) =>
		listDataStreamPoints(streamId, params, { signal, ...requestOptions });

	return {
		queryKey,
		queryFn,
		enabled: streamId !== null && streamId !== undefined,
		...queryOptions,
	} as UseQueryOptions<
		Awaited<ReturnType<typeof listDataStreamPoints>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDataStreamPointsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listDataStreamPoints>>
>;
export type ListDataStreamPointsQueryError =
	| ListDataStreamPoints400
	| ListDataStreamPoints403
	| ListDataStreamPoints404
	| ListDataStreamPoints500;

export function useListDataStreamPoints<
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params: undefined | ListDataStreamPointsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDataStreamPoints>>,
					TError,
					Awaited<ReturnType<typeof listDataStreamPoints>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDataStreamPoints<
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listDataStreamPoints>>,
					TError,
					Awaited<ReturnType<typeof listDataStreamPoints>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDataStreamPoints<
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Query data points for a stream across all fragments. Flat by default; use pointsByFragment=true to see per-fragment boundaries.
 */

export function useListDataStreamPoints<
	TData = Awaited<ReturnType<typeof listDataStreamPoints>>,
	TError =
		| ListDataStreamPoints400
		| ListDataStreamPoints403
		| ListDataStreamPoints404
		| ListDataStreamPoints500,
>(
	streamId: number,
	params?: ListDataStreamPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listDataStreamPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListDataStreamPointsQueryOptions(
		streamId,
		params,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Query data points for a stream across all fragments. Flat by default; use pointsByFragment=true to see per-fragment boundaries.
 */
export const useSetListDataStreamPointsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		streamId: number,
		params: ListDataStreamPointsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listDataStreamPoints>>
			| undefined
			| ((
					old: Awaited<ReturnType<typeof listDataStreamPoints>> | undefined,
			  ) => Awaited<ReturnType<typeof listDataStreamPoints>> | undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listDataStreamPoints>>
		>(
			{
				exact: $exactMatch,
				queryKey: getListDataStreamPointsQueryKey(streamId, params),
			},
			updater,
		);
	};
};

/**
 * @summary Query data points for a stream across all fragments. Flat by default; use pointsByFragment=true to see per-fragment boundaries.
 */
export const useGetListDataStreamPointsQueryData = () => {
	const queryClient = useQueryClient();
	return (streamId: number, params?: ListDataStreamPointsParams) =>
		queryClient.getQueryData<Awaited<ReturnType<typeof listDataStreamPoints>>>(
			getListDataStreamPointsQueryKey(streamId, params),
		);
};

export const getListMultiStreamDataPointsQueryUrl = () => {
	return `/data-points`;
};

/**
 * Served as QUERY /data-points with the input as a JSON body; POST /data-points/query with the same body (deprecated); GET /data-points with the input as query parameters (deprecated). Use QUERY /data-points.
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row.
 */
export const listMultiStreamDataPointsQuery = async (
	listMultiStreamDataPointsQueryBody: ListMultiStreamDataPointsQueryBody,
	options?: Parameters<typeof customFetch>[1],
): Promise<ListMultiStreamDataPointsQuery200> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<ListMultiStreamDataPointsQuery200>(
		getListMultiStreamDataPointsQueryUrl(),
		{
			...options,
			method: "QUERY",
			headers: {
				"Content-Type": "application/json",
				...getHeaders(options?.headers),
			},
			body: JSON.stringify(listMultiStreamDataPointsQueryBody),
		},
	);
};

export const getListMultiStreamDataPointsQueryQueryKey = (
	listMultiStreamDataPointsQueryBody?: ListMultiStreamDataPointsQueryBody,
) => {
	return ["QUERY", "data-points", listMultiStreamDataPointsQueryBody] as const;
};

export const getListMultiStreamDataPointsQueryQueryOptions = <
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
	TError =
		| ListMultiStreamDataPointsQuery400
		| ListMultiStreamDataPointsQuery403
		| ListMultiStreamDataPointsQuery500,
>(
	listMultiStreamDataPointsQueryBody: ListMultiStreamDataPointsQueryBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getListMultiStreamDataPointsQueryQueryKey(
			listMultiStreamDataPointsQueryBody,
		);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
	> = ({ signal }) =>
		listMultiStreamDataPointsQuery(listMultiStreamDataPointsQueryBody, {
			signal,
			...requestOptions,
		});

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMultiStreamDataPointsQueryQueryResult = NonNullable<
	Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
>;
export type ListMultiStreamDataPointsQueryQueryError =
	| ListMultiStreamDataPointsQuery400
	| ListMultiStreamDataPointsQuery403
	| ListMultiStreamDataPointsQuery500;

export function useListMultiStreamDataPointsQuery<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
	TError =
		| ListMultiStreamDataPointsQuery400
		| ListMultiStreamDataPointsQuery403
		| ListMultiStreamDataPointsQuery500,
>(
	listMultiStreamDataPointsQueryBody: ListMultiStreamDataPointsQueryBody,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
					TError,
					Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMultiStreamDataPointsQuery<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
	TError =
		| ListMultiStreamDataPointsQuery400
		| ListMultiStreamDataPointsQuery403
		| ListMultiStreamDataPointsQuery500,
>(
	listMultiStreamDataPointsQueryBody: ListMultiStreamDataPointsQueryBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
					TError,
					Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMultiStreamDataPointsQuery<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
	TError =
		| ListMultiStreamDataPointsQuery400
		| ListMultiStreamDataPointsQuery403
		| ListMultiStreamDataPointsQuery500,
>(
	listMultiStreamDataPointsQueryBody: ListMultiStreamDataPointsQueryBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row.
 */

export function useListMultiStreamDataPointsQuery<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
	TError =
		| ListMultiStreamDataPointsQuery400
		| ListMultiStreamDataPointsQuery403
		| ListMultiStreamDataPointsQuery500,
>(
	listMultiStreamDataPointsQueryBody: ListMultiStreamDataPointsQueryBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListMultiStreamDataPointsQueryQueryOptions(
		listMultiStreamDataPointsQueryBody,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row.
 */
export const useSetListMultiStreamDataPointsQueryQueryData = () => {
	const queryClient = useQueryClient();
	return (
		listMultiStreamDataPointsQueryBody:
			| ListMultiStreamDataPointsQueryBody
			| undefined,
		updater:
			| Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
			| undefined
			| ((
					old:
						| Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
						| undefined,
			  ) =>
					| Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
					| undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
		>(
			{
				exact: $exactMatch,
				queryKey: getListMultiStreamDataPointsQueryQueryKey(
					listMultiStreamDataPointsQueryBody,
				),
			},
			updater,
		);
	};
};

/**
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row.
 */
export const useGetListMultiStreamDataPointsQueryQueryData = () => {
	const queryClient = useQueryClient();
	return (
		listMultiStreamDataPointsQueryBody: ListMultiStreamDataPointsQueryBody,
	) =>
		queryClient.getQueryData<
			Awaited<ReturnType<typeof listMultiStreamDataPointsQuery>>
		>(
			getListMultiStreamDataPointsQueryQueryKey(
				listMultiStreamDataPointsQueryBody,
			),
		);
};

export const getListMultiStreamDataPointsUrl = (
	params: ListMultiStreamDataPointsParams,
) => {
	const normalizedParams = new URLSearchParams();

	Object.entries(params || {}).forEach(([key, value]) => {
		const explodeParameters = ["streamIds"];

		if (Array.isArray(value) && explodeParameters.includes(key)) {
			value.forEach((v) => {
				normalizedParams.append(key, v === null ? "null" : String(v));
			});
			return;
		}

		if (value !== undefined) {
			normalizedParams.append(
				key,
				value === null
					? "null"
					: value instanceof Date
						? value.toISOString()
						: String(value),
			);
		}
	});

	const stringifiedParams = normalizedParams.toString();

	return stringifiedParams.length > 0
		? `/data-points?${stringifiedParams}`
		: `/data-points`;
};

/**
 * Deprecated. Served as QUERY /data-points with the input as a JSON body; POST /data-points/query with the same body (deprecated); GET /data-points with the input as query parameters (deprecated). Use QUERY /data-points.
 * @deprecated
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row. (GET variant)
 */
export const listMultiStreamDataPoints = async (
	params: ListMultiStreamDataPointsParams,
	options?: Parameters<typeof customFetch>[1],
): Promise<ListMultiStreamDataPoints200> => {
	return customFetch<ListMultiStreamDataPoints200>(
		getListMultiStreamDataPointsUrl(params),
		{
			...options,
			method: "GET",
		},
	);
};

export const getListMultiStreamDataPointsQueryKey = (
	params?: ListMultiStreamDataPointsParams,
) => {
	return ["data-points", ...(params ? [params] : [])] as const;
};

export const getListMultiStreamDataPointsQueryOptions = <
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ?? getListMultiStreamDataPointsQueryKey(params);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listMultiStreamDataPoints>>
	> = ({ signal }) =>
		listMultiStreamDataPoints(params, { signal, ...requestOptions });

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMultiStreamDataPointsQueryResult = NonNullable<
	Awaited<ReturnType<typeof listMultiStreamDataPoints>>
>;
export type ListMultiStreamDataPointsQueryError =
	| ListMultiStreamDataPoints400
	| ListMultiStreamDataPoints403
	| ListMultiStreamDataPoints500;

export function useListMultiStreamDataPoints<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
					TError,
					Awaited<ReturnType<typeof listMultiStreamDataPoints>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMultiStreamDataPoints<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
					TError,
					Awaited<ReturnType<typeof listMultiStreamDataPoints>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMultiStreamDataPoints<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @deprecated
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row. (GET variant)
 */

export function useListMultiStreamDataPoints<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
	TError =
		| ListMultiStreamDataPoints400
		| ListMultiStreamDataPoints403
		| ListMultiStreamDataPoints500,
>(
	params: ListMultiStreamDataPointsParams,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPoints>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListMultiStreamDataPointsQueryOptions(
		params,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @deprecated
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row. (GET variant)
 */
export const useSetListMultiStreamDataPointsQueryData = () => {
	const queryClient = useQueryClient();
	return (
		params: ListMultiStreamDataPointsParams | undefined,
		updater:
			| Awaited<ReturnType<typeof listMultiStreamDataPoints>>
			| undefined
			| ((
					old:
						| Awaited<ReturnType<typeof listMultiStreamDataPoints>>
						| undefined,
			  ) => Awaited<ReturnType<typeof listMultiStreamDataPoints>> | undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listMultiStreamDataPoints>>
		>(
			{
				exact: $exactMatch,
				queryKey: getListMultiStreamDataPointsQueryKey(params),
			},
			updater,
		);
	};
};

/**
 * @deprecated
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row. (GET variant)
 */
export const useGetListMultiStreamDataPointsQueryData = () => {
	const queryClient = useQueryClient();
	return (params: ListMultiStreamDataPointsParams) =>
		queryClient.getQueryData<
			Awaited<ReturnType<typeof listMultiStreamDataPoints>>
		>(getListMultiStreamDataPointsQueryKey(params));
};

export const getListMultiStreamDataPointsPostUrl = () => {
	return `/data-points/query`;
};

/**
 * Deprecated: for clients that cannot send QUERY. Served as QUERY /data-points with the input as a JSON body; POST /data-points/query with the same body (deprecated); GET /data-points with the input as query parameters (deprecated). Use QUERY /data-points.
 * @deprecated
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row. (POST variant)
 */
export const listMultiStreamDataPointsPost = async (
	listMultiStreamDataPointsPostBody: ListMultiStreamDataPointsPostBody,
	options?: Parameters<typeof customFetch>[1],
): Promise<ListMultiStreamDataPointsPost200> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<ListMultiStreamDataPointsPost200>(
		getListMultiStreamDataPointsPostUrl(),
		{
			...options,
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				...getHeaders(options?.headers),
			},
			body: JSON.stringify(listMultiStreamDataPointsPostBody),
		},
	);
};

export const getListMultiStreamDataPointsPostQueryKey = (
	listMultiStreamDataPointsPostBody?: ListMultiStreamDataPointsPostBody,
) => {
	return [
		"POST",
		"data-points",
		"query",
		listMultiStreamDataPointsPostBody,
	] as const;
};

export const getListMultiStreamDataPointsPostQueryOptions = <
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>,
	TError =
		| ListMultiStreamDataPointsPost400
		| ListMultiStreamDataPointsPost403
		| ListMultiStreamDataPointsPost500,
>(
	listMultiStreamDataPointsPostBody: ListMultiStreamDataPointsPostBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
) => {
	const { query: queryOptions, request: requestOptions } = options ?? {};

	const queryKey =
		queryOptions?.queryKey ??
		getListMultiStreamDataPointsPostQueryKey(listMultiStreamDataPointsPostBody);

	const queryFn: QueryFunction<
		Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>
	> = ({ signal }) =>
		listMultiStreamDataPointsPost(listMultiStreamDataPointsPostBody, {
			signal,
			...requestOptions,
		});

	return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
		Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>,
		TError,
		TData
	> & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMultiStreamDataPointsPostQueryResult = NonNullable<
	Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>
>;
export type ListMultiStreamDataPointsPostQueryError =
	| ListMultiStreamDataPointsPost400
	| ListMultiStreamDataPointsPost403
	| ListMultiStreamDataPointsPost500;

export function useListMultiStreamDataPointsPost<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>,
	TError =
		| ListMultiStreamDataPointsPost400
		| ListMultiStreamDataPointsPost403
		| ListMultiStreamDataPointsPost500,
>(
	listMultiStreamDataPointsPostBody: ListMultiStreamDataPointsPostBody,
	options: {
		query: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>,
				TError,
				TData
			>
		> &
			Pick<
				DefinedInitialDataOptions<
					Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>,
					TError,
					Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMultiStreamDataPointsPost<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>,
	TError =
		| ListMultiStreamDataPointsPost400
		| ListMultiStreamDataPointsPost403
		| ListMultiStreamDataPointsPost500,
>(
	listMultiStreamDataPointsPostBody: ListMultiStreamDataPointsPostBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>,
				TError,
				TData
			>
		> &
			Pick<
				UndefinedInitialDataOptions<
					Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>,
					TError,
					Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>
				>,
				"initialData"
			>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMultiStreamDataPointsPost<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>,
	TError =
		| ListMultiStreamDataPointsPost400
		| ListMultiStreamDataPointsPost403
		| ListMultiStreamDataPointsPost500,
>(
	listMultiStreamDataPointsPostBody: ListMultiStreamDataPointsPostBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @deprecated
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row. (POST variant)
 */

export function useListMultiStreamDataPointsPost<
	TData = Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>,
	TError =
		| ListMultiStreamDataPointsPost400
		| ListMultiStreamDataPointsPost403
		| ListMultiStreamDataPointsPost500,
>(
	listMultiStreamDataPointsPostBody: ListMultiStreamDataPointsPostBody,
	options?: {
		query?: Partial<
			UseQueryOptions<
				Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>,
				TError,
				TData
			>
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
	queryKey: DataTag<QueryKey, TData, TError>;
} {
	const queryOptions = getListMultiStreamDataPointsPostQueryOptions(
		listMultiStreamDataPointsPostBody,
		options,
	);

	const query = useQuery(queryOptions, queryClient) as UseQueryResult<
		TData,
		TError
	> & { queryKey: DataTag<QueryKey, TData, TError> };

	return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @deprecated
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row. (POST variant)
 */
export const useSetListMultiStreamDataPointsPostQueryData = () => {
	const queryClient = useQueryClient();
	return (
		listMultiStreamDataPointsPostBody:
			| ListMultiStreamDataPointsPostBody
			| undefined,
		updater:
			| Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>
			| undefined
			| ((
					old:
						| Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>
						| undefined,
			  ) =>
					| Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>
					| undefined),
		$exactMatch: boolean = true,
	) => {
		queryClient.setQueriesData<
			Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>
		>(
			{
				exact: $exactMatch,
				queryKey: getListMultiStreamDataPointsPostQueryKey(
					listMultiStreamDataPointsPostBody,
				),
			},
			updater,
		);
	};
};

/**
 * @deprecated
 * @summary Query data points across multiple streams. Points are interleaved by occurredAt with streamId on each row. (POST variant)
 */
export const useGetListMultiStreamDataPointsPostQueryData = () => {
	const queryClient = useQueryClient();
	return (
		listMultiStreamDataPointsPostBody: ListMultiStreamDataPointsPostBody,
	) =>
		queryClient.getQueryData<
			Awaited<ReturnType<typeof listMultiStreamDataPointsPost>>
		>(
			getListMultiStreamDataPointsPostQueryKey(
				listMultiStreamDataPointsPostBody,
			),
		);
};

export const getExportDataStreamsCsvUrl = () => {
	return `/data-streams/export/csv`;
};

/**
 * @summary Export data streams as one wide CSV: a Date column, then one value column per stream or fragment.
 */
export const exportDataStreamsCsv = async (
	exportDataStreamsCsvBody: ExportDataStreamsCsvBody,
	options?: Parameters<typeof customFetch>[1],
): Promise<string> => {
	const getHeaders = (
		h?: NonNullable<RequestInit["headers"]>,
	): Record<string, string | readonly string[]> => {
		if (!h) return {};
		if (h instanceof Headers) return Object.fromEntries(h.entries());
		if (Symbol.iterator in h) {
			return Object.fromEntries(
				Array.from(
					h as Iterable<Iterable<string>>,
					(entry) => Array.from(entry) as [string, string],
				),
			);
		}
		const headers: Record<string, string | readonly string[]> = {};
		for (const [name, value] of Object.entries<
			string | readonly string[] | undefined
		>(h)) {
			if (value !== undefined) headers[name] = value;
		}
		return headers;
	};
	return customFetch<string>(getExportDataStreamsCsvUrl(), {
		...options,
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			...getHeaders(options?.headers),
		},
		body: JSON.stringify(exportDataStreamsCsvBody),
	});
};

export const getExportDataStreamsCsvMutationKey = () =>
	["exportDataStreamsCsv"] as const;

export const getExportDataStreamsCsvMutationOptions = <
	TError =
		| ExportDataStreamsCsv400
		| ExportDataStreamsCsv404
		| ExportDataStreamsCsv422
		| ExportDataStreamsCsv429
		| ExportDataStreamsCsv500
		| ExportDataStreamsCsv503
		| ExportDataStreamsCsv504,
	TContext = unknown,
>(options?: {
	mutation?: UseMutationOptions<
		Awaited<ReturnType<typeof exportDataStreamsCsv>>,
		TError,
		ExportDataStreamsCsvMutationVariables,
		TContext
	>;
	request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
	Awaited<ReturnType<typeof exportDataStreamsCsv>>,
	TError,
	ExportDataStreamsCsvMutationVariables,
	TContext
> => {
	const mutationKey = getExportDataStreamsCsvMutationKey();
	const { mutation: mutationOptions, request: requestOptions } = options
		? options.mutation &&
			"mutationKey" in options.mutation &&
			options.mutation.mutationKey
			? options
			: { ...options, mutation: { ...options.mutation, mutationKey } }
		: { mutation: { mutationKey }, request: undefined };

	const mutationFn: MutationFunction<
		Awaited<ReturnType<typeof exportDataStreamsCsv>>,
		ExportDataStreamsCsvMutationVariables
	> = (props) => {
		const { data } = props ?? {};

		return exportDataStreamsCsv(data, requestOptions);
	};

	return { mutationFn, ...mutationOptions };
};

export type ExportDataStreamsCsvMutationResult = NonNullable<
	Awaited<ReturnType<typeof exportDataStreamsCsv>>
>;
export type ExportDataStreamsCsvMutationBody = ExportDataStreamsCsvBody;
export type ExportDataStreamsCsvMutationError =
	| ExportDataStreamsCsv400
	| ExportDataStreamsCsv404
	| ExportDataStreamsCsv422
	| ExportDataStreamsCsv429
	| ExportDataStreamsCsv500
	| ExportDataStreamsCsv503
	| ExportDataStreamsCsv504;
export type ExportDataStreamsCsvMutationVariables = {
	data: ExportDataStreamsCsvBody;
};

/**
 * @summary Export data streams as one wide CSV: a Date column, then one value column per stream or fragment.
 */
export const useExportDataStreamsCsv = <
	TError =
		| ExportDataStreamsCsv400
		| ExportDataStreamsCsv404
		| ExportDataStreamsCsv422
		| ExportDataStreamsCsv429
		| ExportDataStreamsCsv500
		| ExportDataStreamsCsv503
		| ExportDataStreamsCsv504,
	TContext = unknown,
>(
	options?: {
		mutation?: UseMutationOptions<
			Awaited<ReturnType<typeof exportDataStreamsCsv>>,
			TError,
			ExportDataStreamsCsvMutationVariables,
			TContext
		>;
		request?: SecondParameter<typeof customFetch>;
	},
	queryClient?: QueryClient,
): UseMutationResult<
	Awaited<ReturnType<typeof exportDataStreamsCsv>>,
	TError,
	ExportDataStreamsCsvMutationVariables,
	TContext
> => {
	return useMutation(
		getExportDataStreamsCsvMutationOptions(options),
		queryClient,
	);
};
